class IaPagination extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("[data-ia-pagination-next]");
    this.controls = this.querySelector("[data-ia-pagination-controls]");
    this.sectionId = this.dataset.sectionId || "";
    this.paginationKey = this.dataset.paginationKey || "";
    this.currentPage = Number(this.dataset.currentPage || 1);
    this.totalPages = Number(this.dataset.totalPages || 1);

    this.onClick = this.onClick.bind(this);
    this.button?.addEventListener("click", this.onClick);
    this.syncVisibility();
  }

  disconnectedCallback() {
    this.button?.removeEventListener("click", this.onClick);
  }

  syncVisibility() {
    const isDone = this.currentPage >= this.totalPages;
    if (this.controls) this.controls.hidden = isDone;
    if (this.button) this.button.hidden = isDone;
  }

  async onClick() {
    if (!this.button || this.currentPage >= this.totalPages) return;

    const nextPage = this.currentPage + 1;
    this.button.disabled = true;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set("page", String(nextPage));
      url.searchParams.set("section_id", this.sectionId);

      const response = await fetch(url.toString(), {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok) throw new Error(`Pagination request failed: ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const sourcePagination = this.paginationKey
        ? doc.querySelector(`ia-pagination[data-pagination-key="${this.paginationKey}"]`)
        : doc.querySelector("ia-pagination");
      if (!sourcePagination) throw new Error("Pagination container not found");

      const sourceItems = Array.from(sourcePagination.querySelectorAll("[data-ia-pagination-item]"));
      const targetItems = Array.from(this.querySelectorAll("[data-ia-pagination-item]"));
      const targetContainer = targetItems[0]?.parentElement;
      if (!targetContainer) throw new Error("Pagination target container not found");
      if (sourceItems.length === 0) {
        this.currentPage = nextPage;
        this.dataset.currentPage = String(nextPage);
        this.syncVisibility();
        return;
      }

      sourceItems.forEach((item) => targetContainer.appendChild(item));

      const sourceCurrentPage = Number(sourcePagination.dataset.currentPage || nextPage);
      const sourceTotalPages = Number(sourcePagination.dataset.totalPages || this.totalPages);

      this.currentPage = sourceCurrentPage;
      this.totalPages = sourceTotalPages;
      this.dataset.currentPage = String(sourceCurrentPage);
      this.dataset.totalPages = String(sourceTotalPages);
      this.syncVisibility();

      this.dispatchEvent(
        new CustomEvent("ia-pagination:items-appended", {
          bubbles: true,
          detail: { paginationKey: this.paginationKey },
        })
      );
    } catch (error) {
      console.error("[ia-pagination] Load more failed", error);
    } finally {
      if (this.button && !this.button.hidden) this.button.disabled = false;
    }
  }
}

if (!customElements.get("ia-pagination")) {
  customElements.define("ia-pagination", IaPagination);
}
